import { useState as E, useEffect as B } from "react";
import { isOptionSelected as m } from "../utils/combobox.utils.js";
import { useSearchList as D } from "./use-search-list.js";
const W = (P) => {
  const {
    value: n,
    options: O,
    disabled: r,
    hasError: g,
    placeholder: h,
    onChange: c,
    isOptionEqualToValue: l,
    getOptionLabel: S,
    getOptionValue: i,
    optionFilter: C
  } = P, [u, p] = E(!1);
  B(() => {
    r && p(!1);
  }, [r]);
  const t = D({
    options: u ? O : [],
    getOptionLabel: S,
    optionFilter: C
  }), f = (e) => {
    const o = n.some(
      (a) => m(e, a, i, l)
    );
    let s;
    o ? s = n.filter(
      (a) => l ? l(e, a) : i(e) !== a
    ) : s = [...n, i(e)], c(s);
  }, I = (e) => () => {
    const o = n.filter((s) => s !== e);
    c(o);
  }, d = (e) => {
    t.reset(), p(r ? !1 : e);
  }, M = () => {
    c([]);
  }, V = (e) => {
    if (t.getWrapperProps().onKeyDown?.(e), e.key === "Enter" && t.highlightIndex !== null) {
      const o = t.filteredOptions[t.highlightIndex];
      p(!1), f(o);
    }
  }, w = () => ({
    value: n,
    isMenuOpen: u,
    disabled: r,
    hasError: g,
    placeholder: h,
    setIsMenuOpen: d,
    onClear: M
  }), x = (e) => {
    const o = t.filteredOptions[e];
    return {
      ...t.getOptionProps(e),
      isSelected: n.some(
        (s) => m(o, s, i, l)
      ),
      onClick: () => {
        p(!1), f(o);
      }
    };
  }, y = () => ({
    ...t.getWrapperProps(),
    onKeyDown: V
  }), L = (e) => ({
    disabled: r,
    onRemove: I(e)
  }), b = O.filter(
    (e) => n.some(
      (o) => l ? l(e, o) : i(e) === o
    )
  );
  return {
    value: n,
    disabled: r,
    hasError: g,
    placeholder: h,
    valueOptions: b,
    isOpen: u,
    options: t.filteredOptions,
    setIOpen: d,
    onSelectOption: f,
    getRootProps: w,
    getOptionProps: x,
    getSearchBoxProps: t.getSearchBoxProps,
    getListProps: t.getListProps,
    getContentProps: y,
    getValueMultipleItemProps: L
  };
};
export {
  W as useComboboxMultiple
};
